// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"505":"css/portal","540":"css/landing","678":"css/trading","824":"css/logistics"}[chunkId] + ".css";
};